import axios from 'axios'

const api = axios.create({
  baseURL: 'https://cpro50046.publiccloud.com.br:8443',
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'false',
    'Content-Type': 'application/json',
  },
})

export const getGrupos = async () => {
  try {
    const res = await api.get(`/alimentos/categories`)

    console.log(res.data)
    return res.data
  } catch (error) {
    console.log('error: ', error)
  }
}

export const getAlimentosByGrupoId = async (id) => {
  try {
    const res = await api.get(`/alimentos/categories/${id}`)

    console.log(res.data)
    return res.data
  } catch (error) {
    console.log('error: ', error)
  }
}

export const getAlimentos = async () => {
  try {
    const res = await api.get(`/alimentos`)

    console.log(res.data)
    return res.data
  } catch (error) {
    console.log('error: ', error)
  }
}

export const getDoencas = async () => {
  try {
    const res = await api.get(`/doencas`)

    console.log(res.data)
    return res.data
  } catch (error) {
    console.log('error: ', error)
  }
}

export const getNutrientes = async (id) => {
  try {
    const res = await api.get(`/doencas/${id}/nutrientes/`)

    console.log(res.data)
    return res.data
  } catch (error) {
    console.log('error: ', error)
  }
}

export const getExames = async (id) => {
  try {
    const res = await api.get(`/doencas/${id}/exames/`)

    console.log(res.data)
    return res.data
  } catch (error) {
    console.log('error: ', error)
  }
}

export const getExameFaixaEtaria = async (doencaid, exameid) => {
  try {
    const res = await api.get(`/doencas/${doencaid}/exames/${exameid}/faixa`)

    console.log(res.data)
    return res.data
  } catch (error) {
    console.log('error: ', error)
  }
}

export const downloadRelatorioPdf = async (date, userId, nutrientes) => {
  try {
    const body = {
      date: date,
      userId: userId,
      nutrientes: nutrientes,
    }

    const res = await api.post(`/diario/pdf/download`, body, {
      responseType: 'blob',
      headers: {
        Accept: 'application/octet-stream',
      },
    })

    console.log(res.data)
    const fileURL = window.URL.createObjectURL(new Blob([res.data]))
    const fileName = `amino-relatorio-consumo${date}.pdf`
    return { fileURL: fileURL, fileName: fileName }
  } catch (error) {
    if (error.response.status == 404) {
      throw 'Não há refeições cadastradas para este dia'
    } else {
      throw 'Erro ao baixar pdf, tente novamente mais tarde'
    }
  }
}

export const hasDiarioWeek = async (userId, dateStart, dateEnd) => {
  try {
    const body = {
      userId,
      dateStart,
      dateEnd,
      userId,
    }
    console.log(body)
    const res = await api.post(`/diario/semana/exists`, body)

    console.log(res.data)
    return res.data
  } catch (error) {
    console.log('error: ', error)
    throw error.response.data.response
  }
}

export const hasDiarioDay = async (userId, dateDiario, weekId, dayName) => {
  try {
    const body = {
      userId,
      dateDiario,
      weekId,
      dayName,
    }
    console.log(body)
    const res = await api.post(`/diario/dia/exists`, body)

    console.log(res.data)
    return res.data
  } catch (error) {
    console.log('error: ', error)
    throw error.response.data.response
  }
}

export const createRefInDay = async (alimentos, date, userId, ref_id) => {
  try {
    const body = {
      date,
      userId,
      ref_id,
      alimentos,
    }
    console.log(body)
    const res = await api.post(`diario/dia/refeicao`, body)

    console.log(res)
    return res.status
  } catch (error) {
    console.log('error: ', error)
    throw error.response.data.response
  }
}

export const createDiagnostico = async (doencaid, nutrientes, userId) => {
  try {
    const body = {
      userId,
      doencaid,
      nutrientes,
    }
    console.log(body)
    const res = await api.post(`exames/diagnostico`, body)

    console.log(res)
    return res.status
  } catch (error) {
    console.log('error: ', error)
    throw error.response.status
  }
}

export const deleteAlimentoDiario = async (id) => {
  try {

    const res = await api.delete(`diario/registro/${id}`)

    console.log(res)
    return res.status
  } catch (error) {
    console.log('error: ', error)
    throw error.response.status
  }
}

export const deleteRecipe = async (id) => {
  try {

    const res = await api.delete(`recipe/${id}`)

    console.log(res)
    return res.status
  } catch (error) {
    console.log('error: ', error)
    throw error.response.status
  }
}

export const createRegistroExame = async (
  exameFaixaId,
  doencaId,
  userId,
  exameId,
  resultado,
  dataExame,
  referenciaInicial,
  referenciaFinal,
) => {
  try {
    const body = {
      exameFaixaId,
      userId,
      doencaId,
      exameId,
      resultado,
      dataExame,
      referenciaInicial,
      referenciaFinal,
    }
    console.log(body)
    const res = await api.post(`exames/registro`, body)

    console.log(res)
    return res.status
  } catch (error) {
    console.log('error: ', error)
    throw error.response.status
  }
}

export const getNutrientesDiagnostico = async (userId) => {
  try {
    const res = await api.get(`exames/nutrientes/user/${userId}`)

    console.log(res.data)
    return res.data
  } catch (error) {
    console.log('error: ', error)
    throw error.response.status
  }
}

export const getDiarioHistory = async (userId) => {
  try {
    const res = await api.get(`diario/user/${userId}`)

    console.log(res.data)
    return res.data
  } catch (error) {
    console.log('error: ', error)
    throw error.response.status
  }
}

export const getDiagnostico = async (userId) => {
  try {
    const res = await api.get(`/exames/registro/${userId}`)

    console.log(res.data)
    return res.data
  } catch (error) {
    console.log('error: ', error)
    throw error.response.status
  }
}

export const getRegistroExames = async (userId) => {
  try {
    const res = await api.get(`/exames/resultados/registro/${userId}`)

    console.log(res.data)
    return res.data
  } catch (error) {
    console.log('error: ', error)
    throw error.response.status
  }
}

export const getUserData = async (userId) => {
  try {
    const res = await api.get(`/user/${userId}`)

    console.log(res.data)
    return res.data
  } catch (error) {
    console.log('error: ', error)
    throw error.response.status
  }
}

export const updateUserData = async (userId, userHeight, userWeight) => {
  const body = {
    userId,
    userHeight,
    userWeight,
  }
  try {
    console.log(body)
    const res = await api.post(`/user/data`, body)

    console.log(res)
    return res
  } catch (error) {
    console.log('error: ', error)
    throw error.response.status
  }
}

export const updateNutrientesData = async (userId, nutrientes) => {
  const body = {
    userId,
    nutrientes,
  }
  try {
    console.log(body)
    const res = await api.post(`/exames/nutrientes/update`, body)

    console.log(res)
    return res
  } catch (error) {
    console.log('error: ', error)
    throw error.response.status
  }
}

export const createRecipe = async (body) => {
  try {
    console.log(body)
    const res = await api.post(`/recipe`, body)

    console.log(res)
    return res
  } catch (error) {
    console.log('error: ', error)
    throw error.response.status
  }
}

export const exportTableRecipe = async (body) => {
  try {
    console.log(body)
    const res = await api.post(`/recipe/export/tabela`, body, {
      responseType: 'blob',
      headers: {
        Accept: 'application/octet-stream',
      },
    })

    console.log(res.data)
    const fileURL = window.URL.createObjectURL(new Blob([res.data]))
    const fileName = `tabelaNutricional.pdf`
    return { fileURL: fileURL, fileName: fileName }
  } catch (error) {
    console.log('error: ', error)
    throw error.response.status
  }
}

export const getRecipe = async (userId) => {
  try {
    console.log('get recipe')
    const res = await api.get(`/recipes/${userId}`)

    console.log(res.data)
    return res.data
  } catch (error) {
    console.log('error: ', error)
    throw error.response.status
  }
}

export const signup = async (
  name,
  surname,
  email,
  password,
  height,
  weight,
  born,
) => {
  try {
    const body = {
      name,
      surname,
      email,
      password,
      height,
      weight,
      born,
    }
    const res = await api.post(`/user/signup/`, body)

    console.log(res.data)
    return res.data
  } catch (error) {
    console.log('error: ', error)
    throw error
  }
}

export const login = async (email, password) => {
  try {
    const body = {
      email,
      password,
    }
    const res = await api.post(`/user/login`, body)

    console.log(res.data)
    return res.data
  } catch (error) {
    console.log('error: ', error.message)
    throw error.response.data.response
  }
}
